import { AppForm } from '../../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite
} from '../../../../../../../openapi';
import { toNumber } from '../../../../../../../services/helpers';


@Injectable()
export class MunicipalWasteDisposalDeclarationSubjectForm extends AppForm {

  propertyHasComposterOptions: { key: boolean; value: string }[] = [
    { key: true, value: 'Tak' },
    { key: false, value: 'Nie' }
  ];

  constructor() {
    super({
      voivodeship: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      county: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      municipality: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      postalCode: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      postOffice: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      city: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      street: new FormControl('', {
        validators: [Validators.maxLength(255)],
        nonNullable: true
      }),
      houseNumber: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      apartmentNumber: new FormControl('', Validators.maxLength(255)),

      propertyResidentsCount: new FormControl('', { nonNullable: true, validators: [Validators.required] })
    });
  }

  public get propertyResidentsCount(): FormControl | null {
    return this.get('propertyResidentsCount') as FormControl | null;
  }

  private createPropertyResidentsCountControl(): void {
    this.addControl('propertyResidentsCount', new FormControl('', {
      nonNullable: true,
      validators: [Validators.required]
    }));
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead) {
    if (value?.propertyType === 'Nieruchomości zamieszkałe') {
      this.createPropertyResidentsCountControl();
    }

    super.patchFormValues({
      ...value,
      propertyHasComposter: !!value?.propertyHasComposter
    });
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    return {
      ...this.value,
      propertyResidentsCount: this.propertyResidentsCount ? toNumber(this.propertyResidentsCount.value) : null
    };
  }
}
